<template src="./toolbarStatistiche.html"></template>

<script>
import calendar from "@/components/ui/Calendar";

export default {
  components: { calendar },

  props: {
    role: { type: String, default: "" },
    tabs: { type: String, default: "0" },
    dati: { type: Array },
    update: { type: Boolean, default: false },
    attesa: { type: Boolean, default: false },
    cambioValori: { type: Boolean, default: false },
  },

  data: () => ({
    search: "",

    dataDa: new Date().getFullYear().toString() + "-" + "01" + "-" + "01",
    dataA: new Date().toISOString().substr(0, 10),
    dataDa2: new Date().getFullYear().toString() + "-" + "01" + "-" + "01",
    dataA2: new Date().toISOString().substr(0, 10),

    //attesa: false,
    confrontoDate: false,

    startYear: 2018,
    anni: [],
    annoSel1: 0,
    annoSel2: 0,

    filtriProdotti: [
      { value: "Laminato", gruppo: "Porte" },
      { value: "Laccato Liscio", gruppo: "Porte" },
      { value: "Laccato Alder", gruppo: "Porte" },
      { value: "Laccato Frassino", gruppo: "Porte" },

      { value: "Placard", gruppo: "Arredo" },
      { value: "Sospesi", gruppo: "Arredo" },
      { value: "Rasomuro", gruppo: "Arredo" },
      { value: "Blindato", gruppo: "Sicur" },
    ],
    filtriSel: [],
    tuttiSel: "",
    dataChange: false,
    filtroTipologia: "Quantita",

    dialogDataInizio1: false,
    dialogDataFine1: false,
    dialogDataInizio2: false,
    dialogDataFine2: false,
    dataSelIT1: new Date().toISOString().substr(0, 10),
    dataSelIT2: new Date().toISOString().substr(0, 10),
    dataSelIT3: new Date().toISOString().substr(0, 10),
    dataSelIT4: new Date().toISOString().substr(0, 10),
  }),

  methods: {
    resetFiltri() {
      this.filtriProdotti = [
        { value: "Laminato", gruppo: "Porte" },
        { value: "Laccato Liscio", gruppo: "Porte" },
        { value: "Laccato Alder", gruppo: "Porte" },
        { value: "Laccato Frassino", gruppo: "Porte" },
        { value: "Riflessi di Stile", gruppo: "Porte" },
        { value: "Legno", gruppo: "Porte" },
        { value: "Speedy", gruppo: "Porte" },
        { value: "Timeless", gruppo: "Porte" },

        { value: "Placard", gruppo: "Arredo" },
        { value: "Sospesi", gruppo: "Arredo" },
        { value: "Rasomuro", gruppo: "Arredo" },
        { value: "Blindato", gruppo: "Sicur" },

        { value: "Pop", gruppo: "Pop" },
      ];
      if (this.role == "Admin" || this.role == "AgenteCapo") {
        this.filtriProdotti.push({ value: "Ecorever", gruppo: "Porte" });
      }
    },

    CambioData() {
      if (!this.dataChange) this.dataChange = true;
    },

    refresh() {
      this.dataChange = false;
      let date = {};
      if (this.confrontoDate) {
        date = {
          DataDa1: this.dataDa,
          DataA1: this.dataA,
          DataDa2: this.dataDa2,
          DataA2: this.dataA2,
        };
        if (!this.verificaPeriodi()) return;
      } else {
        date = {
          DataDa1: this.annoSel1 + "-01-01",
          DataA1: this.annoSel1 + "-12-31",
          DataDa2: this.annoSel2 + "-01-01",
          DataA2: this.annoSel2 + "-12-31",
        };
      }
      this.$emit("salvaFiltri", this.filtriSel, this.tuttiSel);
      this.$emit("caricaDatiTabella", date);
    },

    verificaPeriodi() {
      this.setDate();//setto le text-field delle date
      if (this.dataDa >= this.dataA) return false;
      if (this.dataDa2 >= this.dataA2) return false;
      if (this.dataA == this.dataA2 && this.dataDa == this.dataDa2)
        return false;
      return true;
    },

    setDate() {
      let datada = new Date(this.dataDa);
      datada.setDate(datada.getDate()); //formato system
      datada = this.$i2kFunctions.formatDate_IT(datada); //dd/MM//YYYY;
      this.dataSelIT1 = datada;

      let dataa = new Date(this.dataA);
      dataa.setDate(dataa.getDate()); //formato system
      dataa = this.$i2kFunctions.formatDate_IT(dataa); //dd/MM//YYYY;
      this.dataSelIT2 = dataa;

      let datada2 = new Date(this.dataDa2);
      datada2.setDate(datada2.getDate()); //formato system
      datada2 = this.$i2kFunctions.formatDate_IT(datada2); //dd/MM//YYYY;
      this.dataSelIT3 = datada2;

      let dataa2 = new Date(this.dataA2);
      dataa2.setDate(dataa2.getDate()); //formato system
      dataa2 = this.$i2kFunctions.formatDate_IT(dataa2); //dd/MM//YYYY;
      this.dataSelIT4 = dataa2;
    },
  },

  async mounted() {
    this.tuttiSel = "Tutti";
    this.annoSel = this.$i2kFunctions.getYear();

    for (let i = this.startYear; i <= this.annoSel; i++) this.anni.push(i);

    // --- tabella riepilogo
    this.annoSel1 = this.$i2kFunctions.getYear() - 1;
    this.annoSel2 = this.$i2kFunctions.getYear();
    this.dataDa = this.annoSel1 + "-01-01";
    this.dataA = this.annoSel1 + "-12-31";

    await this.resetFiltri();

    this.dataChange = false;
  },

  computed: {
    userSwitch: function () {
      return this.$store.getters["user/getUserSwitch"];
    },

    watchFiltri() {
      return this.filtriSel;
    },
  },

  watch: {
    tabs() {
      if (this.dati == null || this.dati.length <= 0) {
        //this.refresh();
        this.dataChange = true;
      }
    },

    confrontoDate() {
      if (this.confrontoDate == true) this.verificaPeriodi();
    },

    search(newVal) {
      this.$emit("nuovoFiltro", newVal);
    },

    userSwitch() {
      this.refresh();
    },

    watchFiltri() {
      if (this.filtriSel.length != this.filtriProdotti.length)
        this.tuttiSel = false;
      else this.tuttiSel = "Tutti";
      this.dataChange = true;
    },

    tuttiSel(newVal, oldVal) {
      //se seleziono "Tutti" voglio che tutte le checkbox vengano selezionate, altrimenti le deseleziono tutte
      if (newVal == null) {
        this.filtriSel = [];
      } else if (newVal == "Tutti") {
        this.filtriSel = [];
        for (let i = 0; i < this.filtriProdotti.length; i++) {
          this.filtriSel.push(this.filtriProdotti[i].value);
        }
        this.dataChange = true;
      }
    },

    update(newVal) {
      if (newVal) this.refresh();
    },

    dataDa() {
      this.setDate();
    },
    dataA() {
      this.setDate();
    },
    dataDa2() {
      this.setDate();
    },
    dataA2() {
      this.setDate();
    },
  },
};
</script>